import BasicRouterView from "../../../components/BasicRouterView.vue";

const compras = {
  path: "comp",
  redirect: { name: "salvos" },
  meta: {
    label: "Compras",
    icon: "task",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "compra/compra-mrp",
      name: "compras-mrp",
      meta: {
        label: "MRP",
        icon: "settings",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "../compras/views/Mrp.vue"),
    },
    {
      path: "compra/compra-upload/:id?",
      name: "compras-upload",
      meta: {
        label: "Upload",
        icon: "settings",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "../compras/views/Upload.vue"),
    },

    {
      path: "compra/compra-manual/:id?",
      name: "compras-manual",
      meta: {
        label: "Manual",
        icon: "settings",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "../compras/views/Manual.vue"),
    },

    {
      path: "compra/compra-manual-mrp",
      name: "compras-manual-mrp",
      meta: {
        label: "Nova Necessidade de Compra com base no MRP",
        icon: "settings",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../compras/views/NovaManualMrp.vue"
        ),
    },

    {
      path: "compra/compra-produto/:id?",
      name: "compras-produtos",
      meta: {
        label: "Produtos",
        icon: "settings",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "../compras/views/Produtos.vue"),
    },
    {
      path: "compra/compra-necessidade",
      name: "compras-necessidades",
      meta: {
        label: "Necessidades",
        icon: "settings",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../compras/views/Necessidades.vue"
        ),
    },
    {
      path: "compra/compra-criar/:id?",
      name: "compras-criar",
      meta: {
        label: "Criar Pedido",
        icon: "settings",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../compras/views/CriarPedido.vue"
        ),
    },
    {
      path: "compra/compra-listagem-pedidos",
      name: "compras-listagem-pedidos",
      meta: {
        label: "Lista Pedidos",
        icon: "settings",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../compras/views/ListaPedidos.vue"
        ),
    },

    {
      path: "compra/compra-acompanhar/:id",
      name: "compras-acompanhar",
      meta: {
        label: "Compra Acompanhar",
        icon: "settings",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "../compras/views/Acompanhar.vue"),
    },

    {
      path: "compra/compra-imprimir/:id",
      name: "compras-imprimir",
      meta: {
        label: "Compra Imprimir",
        icon: "settings",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../compras/views/ImprimirNecessidade.vue"
        ),
    },
    {
      path: "compra/compra-detalhe/:id",
      name: "compras-detalhe",
      meta: {
        label: "Compra Detalhe",
        icon: "settings",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../compras/views/NecessidadeDetalhe.vue"
        ),
    },

    {
      path: "compra/compra-imprimir-pedidos/:id",
      name: "compras-imprimir-pedidos",
      meta: {
        label: "Compra Imprimir Pedidos",
        icon: "settings",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../compras/views/ImprimirPedidos.vue"
        ),
    },
    {
      path: "compra/compra-pedidos-abertos/:id?",
      name: "compras-pedidos-abertos",
      meta: {
        label: "Compra Pedidos Abertos",
        icon: "settings",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../compras/views/ListaPedidosAbertos.vue"
        ),
    },
    {
      path: "compra/compra-receber/:id",
      name: "compras-receber",
      meta: {
        label: "Compra Receber",
        icon: "settings",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../compras/views/PedidosReceber.vue"
        ),
    },
    {
      path: "compra/compra-editar/:id",
      name: "compras-editar",
      meta: {
        label: "Compra Editar",
        icon: "settings",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../compras/views/ComprasEditar.vue"
        ),
    },
    {
      path: "compra/compra-form-sup/:id",
      name: "compras-form-sup",
      meta: {
        label: "Formulario Suprimento",
        icon: "settings",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "../compras/views/FormSup.vue"),
    },
  ],
};

export default compras;
